import { defaultHttpClient } from '../../httpClient';

export const postParticipateLiveCampaign = (eventSno: number) => {
  return defaultHttpClient
    .request<{ text: string }>({
      method: 'POST',
      url: `/api/v2/events/${eventSno}/participate/`,
    })
    .then(result => result.data)
    .then(result => result.text);
};
